var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business-products-magic-rabbit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.475,12.19h-1.52v3.05h-1.53V13.72h-1.52V12.19h3.05V10.67h-3.05V9.14h-1.52v6.1h-1.53v1.52H9.145V15.24H7.615V9.14H6.1v1.53H3.045v1.52H6.1v1.53H4.575v1.52H3.045V12.19H1.525v4.57h1.52v1.53H6.1V28.95h1.52v1.53h1.53V32h13.71V30.48h1.53V28.95h1.52V18.29h3.05V16.76h1.52Zm-6.09,9.15H7.615V19.81h16.77Z",
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.855,
    y: 7.62,
    width: 1.53,
    height: 1.52,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.855,
    y: 1.53,
    width: 1.53,
    height: 3.04,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.335,
    y: 4.57,
    width: 1.52,
    height: 3.05,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.805,
    width: 3.05,
    height: 1.53,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.805,
    y: 10.67,
    width: 1.53,
    height: 1.52,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.285,
    y: 1.53,
    width: 1.52,
    height: 3.04,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.765,
    y: 4.57,
    width: 1.52,
    height: 1.53,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.235 15.24 16.765 15.24 16.765 13.72 18.285 13.72 18.285 12.19 13.715 12.19 13.715 13.72 15.235 13.72 15.235 15.24",
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.235,
    y: 6.1,
    width: 1.53,
    height: 1.52,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.715,
    y: 4.57,
    width: 1.52,
    height: 1.53,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.185,
    y: 1.53,
    width: 1.53,
    height: 3.04,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.665,
    y: 10.67,
    width: 1.52,
    height: 1.52,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.145,
    width: 3.04,
    height: 1.53,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.145,
    y: 4.57,
    width: 1.52,
    height: 3.05,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.615,
    y: 7.62,
    width: 1.53,
    height: 1.52,
    fill: "#33b1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.615,
    y: 1.53,
    width: 1.53,
    height: 3.04,
    fill: "#33b1ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0147132261a9561f8c3ad8dad37e4be6.svg";
export { ForwardRef as ReactComponent };